import React, { useState } from "react";
import Input from "../../../components/input";
import Button from "../../../components/ui/button";
import {
  checkPasswords,
  displayErrorMsg,
} from "../../../utils/displayErrorMsg";
import { IResetPassword, TKey } from "../../../types";
import { useNavigate, useSearchParams } from "react-router-dom";
import { validatePassword } from "../../../utils/validatePassword";
import colors from "../../../utils/colors";
import { useResetPassword } from "../../../apis/doctor";
import AuthenticationModal from "../AuthenticationModal";
import { verified } from "../../../assets";

const ResetPasswordForm = () => {
  const [details, setDetails] = useState<IResetPassword>({} as IResetPassword);
  const [submitting, setSubmitting] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams?.get("token");

  const { mutate, isPending } = useResetPassword();

  const updateState = (name: TKey, value: string) => {
    setDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  return (
    <div className="w-full flex gap-[24px] flex-col">
      <div>
        <Input
          handleChange={(e) => updateState("password", e)}
          property="password"
          submitting={false}
          value={details.password}
          title="Enter new password"
          placeholder="Enter password"
          inputStyles="!py-[14px]"
          isPassword
        />
        {displayErrorMsg(
          "Password can not be empty",
          details.password,
          submitting
        )}
        {details?.password && !validatePassword(details.password) && (
          <div className="text-[red] text-left text-[11px]">
            Password must not be less than 6 digits
          </div>
        )}
      </div>

      <div>
        <Input
          handleChange={(e) => updateState("confirmPassword", e)}
          property="confirmPassword"
          submitting={false}
          value={details.confirmPassword}
          title="Confirm password"
          placeholder="Enter password"
          inputStyles="!py-[14px]"
          isPassword
        />
        {displayErrorMsg(
          "Password can not be empty",
          details.password,
          submitting
        )}
        {checkPasswords(
          details?.password,
          details?.confirmPassword,
          "Passwords do not match"
        )}
      </div>

      <Button
        theme="primary"
        text="Reset Password"
        className="w-full rounded-md"
        onClick={() => {
          setSubmitting(true);
          if (
            validatePassword(details?.password) &&
            details?.password === details?.confirmPassword
          ) {
            mutate(
              {
                password: details?.password,
                resetToken: token ?? "",
              },
              {
                onSuccess: () => {
                  setOpen(true);
                },
              }
            );
          }
        }}
        loading={isPending}
      />

      <Button
        theme="tertiary-primary"
        text="Back to login"
        className="w-full rounded-md"
        onClick={() => {
          navigate("/login")
        }}
      />

      <div
        className="font-lato text-[18px] font-[400] leading-normal mt-[-0px] text-center"
        style={{ color: colors.dark }}
      >
        By clicking this, you agree to our {` `}
        <span style={{ color: colors.primary }}>
          Terms of Use
        </span> {` and `} <br />
        <span style={{ color: colors.primary }}>Privacy Policy</span>
      </div>

      <AuthenticationModal
        btnText="Log into your account"
        headerText="Password reset successfully"
        image={verified}
        isOpen={open}
        onClose={setOpen}
        subText="Your password has been changed. You can now log into your account with your new password"
        title=""
        onclickProceed={() => {
          navigate("/login");
        }}
      />
    </div>
  );
};

export default ResetPasswordForm;
